import React from "react";

import Buttons from "./Buttons";
import styles from "./Footer.module.scss";

interface Props {
  checkoutEnabled: boolean;
  hideCheckout: boolean;
  onCheckoutClick: () => void;
}

const Footer: React.FC<Props> = ({ checkoutEnabled, hideCheckout, onCheckoutClick }) => {
  return (
    <section className={styles.container}>
      <Buttons
        checkoutEnabled={checkoutEnabled}
        hideCheckout={hideCheckout}
        onCheckoutClick={onCheckoutClick}
      />
    </section>
  );
};

export default Footer;
